import React,{useContext,useEffect, useState, useRef, useCallback, useReducer,useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, EditRowIcon, DeleteIcon, EditIcon, PaperClipIcon, RefreshIcon } from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import UtilContext from '../../components/UtilContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { cleanSorters, parseSorters, parseMaskFilters, safeParse, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart } from '../../utils/tabulatorProgressiveLoading';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { scrollToFirst, scrollUp, scrollDown, scrollToLast } from '../../utils/tabulatorScroll';
import { getDateFormat } from '../../utils/dateUtils';
import { getPusherChannel } from '../../utils/pusherChannel';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
export default function GaugeCalibrationAdd({gauge,gauge_calibration, type, templateCalibration, navigationContext = null}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview, openChosenNotificationPreferences} = useContext(UtilContext);
    const dateFmt = getDateFormat(state?.module_settings || []);
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const useMaskDefaultsRef = useRef(true);
    const gaugeIdRef = useRef(null);
    const PAGE_SIZE = 50;
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

    const [formGauge, setFormGauge] = useState(gauge ?? (gauge_calibration ? { id: gauge_calibration.gauge_id ?? gauge_calibration.id } : null));
    useEffect(() => {
        setFormGauge(gauge ?? (gauge_calibration ? { id: gauge_calibration.gauge_id ?? gauge_calibration.id } : null));
    }, [gauge, gauge_calibration]);

    const effectiveGaugeId = formGauge?.id ?? gauge?.id ?? gauge_calibration?.gauge_id ?? gauge_calibration?.id;
    gaugeIdRef.current = effectiveGaugeId ?? null;

    const [markUnmark, setMarkUnmarked] = useState(true);

    const DEFAULT_COLUMNS_VISIBLE_GAUGE_CALIBRATION_ADD = { custom_validator_name: true, custom_calibration_date: true, calibration_number_protocol: true, next_calibration_date: true, verification_result: true, 'contractor.name': true, description: true, protocol: true };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_GAUGE_CALIBRATION_ADD });
    const [maskVisible, setMaskVisible] = useState(false);
const [formGaugeCalibration,setFormGaugeCalibration] = useState(gauge_calibration ?? gauge);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add calibration"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit calibration"))?false:true);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [visibleCalibration,setVisibleCalibration] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);

    const [selectedCalibration,setSelectedCalibration] = useState(null);

    const [showGaugeCalibrationAdd, setShowGaugeCalibrationAdd] = useState(false);
    const [showIntervalCalibration, setShowIntervalCalibration] = useState(false);
    const [images,setImages] = useState([]);
    const [templates,setTemplates] = useState([]);

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    useEffect(() => {
        // Update the document title using the browser API
        if(formGaugeCalibration!=null){
            getTemplates(formGaugeCalibration.id);
        }
    },[formGaugeCalibration]);

    const replaceTableData = useCallback(() => {
        refreshFromStart();
    }, [getTable]);

    useEffect(() => {
        if (tableBuiltRef.current && formGauge?.id) replaceTableData();
    }, [formGauge?.id, replaceTableData]);

    useEffect(() => {
        if (type === 'add' && gauge) {
            setFormGaugeCalibration(gauge);
            formik.setValues({
                validator_id: templateCalibration?.validator_id ?? '',
                calibration_date: '',
                calibration_number_protocol: '',
                verification_result: templateCalibration?.verification_result ?? 'OK',
                contractor_id: templateCalibration?.contractor_id ?? '',
                description: templateCalibration?.description ?? '',
            });
            setShowGaugeCalibrationAdd(true);
        }
        if (type === 'edit' && gauge?.gauge_calibrations?.length > 0) {
            const firstCal = gauge.gauge_calibrations[0];
            setSelectedCalibration(firstCal);
            getImages(firstCal.id);
        }
    }, [type, gauge, templateCalibration]);

    function addNewCalibration(){
        setShowGaugeCalibrationAdd(true);
    }

    function copyGaugeCalibration(){
        const sel = getTable()?.getSelectedData?.()?.[0];
        if (sel) { formik.setValues(sel); setShowGaugeCalibrationAdd(true); }
    }

    function editNewGaugeCalibration(){
        const sel = getTable()?.getSelectedData?.()?.[0];
        if (sel) formikUpdate.setValues(sel);
        setVisibleCalibration(true);
    }

    function hideEditCalibration(){
        formikUpdate.resetForm();
        setVisibleCalibration(false);
    }

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        const data = getTable()?.getSelectedData?.() ?? [];
        if (data.length === 1) {
            if (user.permissions?.includes("edit calibration")) setEditIcon(false);
            if (user.permissions?.includes("delete calibration")) setDeleteIcon(false);
            if (user.permissions?.includes("add calibration")) setCopyIcon(false);
            setSelectedCalibration(data[0]);
            getImages(data[0].id);
        } else {
            setSelectedCalibration(null);
            setImages([]);
        }
    }

    function getImages(calibrationId){
        const id = calibrationId ?? selectedCalibration?.id;
        if (!id) { setImages([]); return; }
        getRequest(`/api/gauge_calibrations/protocols/${id}`).then((response) => {
            const list = response?.data?.data ?? [];
            setImages(Array.isArray(list) ? list : []);
        }).catch(() => setImages([]));
    }

    function getTemplates(id=null){
        const gaugeId = id ?? formGaugeCalibration?.id ?? selectedCalibration?.id;
        if (!gaugeId) { setTemplates([]); return; }
        getRequest(`/api/gauges/protocols/${gaugeId}`).then((response) => {
            const list = response?.data?.data ?? [];
            setTemplates(Array.isArray(list) ? list : []);
        }).catch(() => setTemplates([]));
    }


    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues:{
            validator_id: '',calibration_date: '',calibration_number_protocol:'',verification_result:'OK',contractor_id:'',description:'',},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            if (gauge?.required_attachment) {
                if (!fileList || fileList.length === 0) {
                    toast?.current?.show({ severity: 'warn', summary: t('Common.MandatoryAttachment'), detail: t('Calibration.GaugeAttachmentRequired'), life: 5000 });
                    return;
                }
            }
            let formData = new FormData();
            if(values.validator_id == "Interne"){
                values.validator_id = null;
            }
            for (let value in values) {
                formData.append(value, values[value]);
            }
            for(let i = 0;i<fileList.length;i++){
                //console.log("IMAGE :"+fileList[i].name);
                formData.append('files[]',fileList[i]);
            }
            formData.append("gauge_id", gauge?.id);
            postRequest('/api/gauge_calibrations', formData,true)
            .then((response) => {
                replaceTableData();
                if (navigationContext) {
                    dispatch({ type: 'refresh_gauge_calibration_list' });
                    dispatch({ type: 'refresh_calibration_state_list' });
                }
                if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                formik.resetForm();
                if(fileList.length){
                    setFileList([]);
                    fileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                setShowGaugeCalibrationAdd(false);
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    const msg = reason?.response?.data?.message || reason?.message || t('Common.Toast.ActionFailedDetail');
                    toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: msg, life: 5000 });
                }
            });
        },
    });

    const formikUpdate = useFormik({
        initialValues: selectedCalibration == null ? {
            validator_id: 'Interne',calibration_date: '',calibration_number_protocol:'',verification_result:'OK',contractor_id:'',description:'',} : selectedCalibration,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            if (gauge?.required_attachment) {
                const hasNewFiles = updatefileList && updatefileList.length > 0;
                const hasExistingFiles = Array.isArray(images) && images.length > 0;
                if (!hasNewFiles && !hasExistingFiles) {
                    toast?.current?.show({ severity: 'warn', summary: t('Common.MandatoryAttachment'), detail: t('Calibration.GaugeAttachmentRequired'), life: 5000 });
                    return;
                }
            }
            let formData = new FormData();
            delete values.files;
            if(values.validator_id == "Interne"){
                values.validator_id = "";
            }
            for (let value in values) {
                formData.append(value, values[value]);
            }
            for(let i = 0;i<updatefileList.length;i++){
                //console.log("IMAGE :"+fileList[i].name);
                formData.append('files[]',updatefileList[i]);
            }
            formData.append("gauge_id",  gauge?.id);
            postRequest(`/api/gauge_calibrations/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                replaceTableData();
                if (navigationContext) {
                    dispatch({ type: 'refresh_gauge_calibration_list' });
                    dispatch({ type: 'refresh_calibration_state_list' });
                }
                if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                setVisibleCalibration(false);
                formikUpdate.resetForm();
                if(updatefileList.length){
                    setUpdateFileList([]);
                    updateFileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    const msg = reason?.response?.data?.message || reason?.message || t('Common.Toast.ActionFailedDetail');
                    toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: msg, life: 5000 });
                }
            });
        },
    });

    // Pusher: obnov tabuľku kalibrácií; pri otvorenom detaile obnov/zatvor podľa eventu; pri vymazaní meradla zatvor tab
    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel) return;
        const onCalibrationCreated = () => { replaceTableData(); };
        const onCalibrationUpdated = (data) => {
            replaceTableData();
            const id = data?.id ?? null;
            if (id != null && selectedCalibration?.id != null && Number(id) === Number(selectedCalibration.id)) {
                getRequest(`/api/gauge_calibrations/${id}`)
                    .then((res) => {
                        const cal = res?.data ?? res;
                        if (cal) {
                            setSelectedCalibration(cal);
                            formikUpdate.setValues(cal);
                            getImages(cal.id);
                        }
                    })
                    .catch(() => {});
            }
        };
        const onCalibrationDeleted = (data) => {
            replaceTableData();
            const id = data?.id ?? null;
            if (id != null && selectedCalibration?.id != null && Number(id) === Number(selectedCalibration.id)) {
                setVisibleCalibration(false);
            }
        };
        const onGaugeUpdated = (data) => {
            const id = data?.id ?? null;
            if (id == null || effectiveGaugeId == null || Number(id) !== Number(effectiveGaugeId)) return;
            getRequest(`/api/gauges/${id}`)
                .then((res) => {
                    const g = res?.data ?? res;
                    if (g) setFormGauge(g);
                })
                .catch(() => {});
        };
        const onGaugeDeleted = (data) => {
            const id = data?.id ?? null;
            if (id != null && effectiveGaugeId != null && Number(id) === Number(effectiveGaugeId)) {
                dispatch({ type: 'close_tab', id: state.selectedTab });
            }
        };
        channel.bind('gauge_calibration.created', onCalibrationCreated);
        channel.bind('gauge_calibration.updated', onCalibrationUpdated);
        channel.bind('gauge_calibration.deleted', onCalibrationDeleted);
        channel.bind('gauge.updated', onGaugeUpdated);
        channel.bind('gauge.deleted', onGaugeDeleted);
        return () => {
            channel.unbind('gauge_calibration.created', onCalibrationCreated);
            channel.unbind('gauge_calibration.updated', onCalibrationUpdated);
            channel.unbind('gauge_calibration.deleted', onCalibrationDeleted);
            channel.unbind('gauge.updated', onGaugeUpdated);
            channel.unbind('gauge.deleted', onGaugeDeleted);
        };
    }, [replaceTableData, effectiveGaugeId, selectedCalibration?.id, dispatch, state.selectedTab]);

    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (extra.size == null) extra.size = PAGE_SIZE;
        const gaugeId = gaugeIdRef.current ?? formGauge?.id;
        if (gaugeId != null && gaugeId !== '') extra.gauge_id = gaugeId;
        const t = ref.current?.table ?? ref.current;
        const tableReadyForParams = tableBuiltRef.current;
        let hf = [];
        if (tableReadyForParams) hf = t?.getHeaderFilters?.() ?? [];
        if (tableReadyForParams && hf.length) {
            hf.forEach(f => {
                if (f?.field == null) return;
                const v = f.value;
                if (v === undefined || v === null) return;
                if (typeof v === 'object') return;
                const str = String(v).trim();
                if (str === '') return;
                extra[`filter_${f.field}`] = str;
            });
        } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
            const maskRow = (state.user_mask_filters || []).find(m => m.page === 'GaugeCalibrationAdd');
            if (maskRow) {
                parseMaskFilters(maskRow.filters).forEach(f => {
                    if (!f?.field) return;
                    const v = f.value;
                    if (v === undefined || v === null || String(v).trim() === '') return;
                    extra[`filter_${f.field}`] = String(v).trim();
                });
            }
        }
        let sortersFromTable = [];
        if (tableReadyForParams) sortersFromTable = t?.getSorters?.() ?? [];
        const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
        if (hasSorters) {
            const clean = cleanSorters(sortersFromTable);
            if (clean.length > 0) extra.sorters = JSON.stringify(clean);
        } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
            const maskRow = (state.user_mask_filters || []).find(m => m.page === 'GaugeCalibrationAdd');
            if (maskRow?.sorters) {
                const parsed = parseSorters(maskRow.sorters);
                if (parsed.length > 0) extra.sorters = JSON.stringify(parsed);
            }
        }
        return extra;
    }, [formGauge?.id, state.user_mask_filters]);

    const handleFileChange = (event) => {
        setFileList(event.target.files);
    };

    const handleUpdateFileChange = (event) => {
        setUpdateFileList(event.target.files);
    };

    function CalibrationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.calibration_date ? DateTime.fromISO(rowData.calibration_date).toFormat(dateFmt) : t('Calibration.UncalibratedBang');
      }

      function NextCalibrationDate(props) {
        const rowData = props.cell._cell.row.data;
        return rowData.next_calibration_date ? DateTime.fromISO(rowData.next_calibration_date).toFormat(dateFmt) : t('Calibration.UncalibratedBang');
      }

      function VerificationResult(props) {
        const rowData = props.cell._cell.row.data;
        const result = rowData.verification_result ?? rowData.gauge_calibrations?.[0]?.verification_result;
        return result ? result : <span style={{color:'darkred',fontWeight:'bold'}}>{t('Ui.R67.Nehodnotene')}</span>;
      }

      function onEditRow(gauge_calibration){
        formikUpdate.setValues(gauge_calibration);
        setSelectedCalibration(gauge_calibration);
        getImages(gauge_calibration?.id);
        setVisibleCalibration(true);
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

    function editGaugeCalibration(){
        const sel = getTable()?.getSelectedData?.()?.[0];
        if (sel) dispatch({ type: 'create_new_tab', name: t('Calibration.EditGaugeCalibration'), translationKey: 'Calibration.EditGaugeCalibration', legacyLabel: t('Calibration.EditGaugeCalibration'), page: 'GaugeCalibrationAdd', props: { gauge_calibration: sel, type: 'edit' } });
    }

    function Validator(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.validator_id ? rowData.validator.name : <span>Interne</span>;
      }

    function viewFile(file_id){
        getRequest(`/api/gauge_calibrations/protocol/${file_id}`).then((response) => {
            if (response?.data?.url) openFilePreview({ url: response.data.url, filename: response.data.filename });
        });
    }
    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.files ? <div className='flex flex-row'>{rowData.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div> : null;
    }

    const accept = (id) => {
        getRequest(`/api/gauge_calibrations/deleteProtocol/${id}`)
            .then((response) => {
              toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
              replaceTableData();
              getImages(selectedCalibration?.id);
            }).catch((reason) => {
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
            })
      };

      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
      }

    function deleteFiles(img){
        confirmDialog({
            message: t('Common.ConfirmDeleteFile'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => accept(img.id)
        });
    }

    const acceptCalibration = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(element => {
          console.log(element);
          deleteRequest(`/api/gauge_calibrations/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                replaceTableData();
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCalibration
        });
    };
      

    const [columns,setColumns] = useState([
        { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort:false},
        { hozAlign:"center", width: 44, headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
        { title: 'Kalibroval', field: 'custom_validator_name',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<Validator/>)},
        { title: t('Calibration.Column.CalibrationDate'), field: 'custom_calibration_date',editor: "input", minWidth: 200, headerFilter:"input",formatter: reactFormatter(<CalibrationDate/>)},
        { title: t('Calibration.ProtocolNumber'), field: 'calibration_number_protocol',headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.NextCalibrationDate'), field: 'next_calibration_date',headerFilter:"input", minWidth: 260, formatter: reactFormatter(<NextCalibrationDate/>)},
        { title: t('Calibration.Column.VerificationResult'), field: 'verification_result',editor: "input",headerFilter:"input", minWidth: 200},
        { title: t('Calibration.Column.RecordedBy'), field: 'contractor.name',editor: "input",headerFilter:"input", minWidth: 200},
        { title: t('Common.Note'), field: 'description',editor: "input",headerFilter:"input", minWidth: 200},
        { field: 'calibration_date',visible:false,sorter: "date", sorterParams: { format: "yyyy-MM-dd",alignEmptyValues:"bottom",}},
        { title: 'Protokol', field: 'protocol',headerFilter:"input", minWidth: 200, formatter: reactFormatter(<Protocol/>)},
    ]);

    function setMask(item, value) {
        const columnVisible = { ...columnsVisible };
        columnVisible[item] = value;
        const table = getTable();
        for (const val in columnVisible) {
            if (columnVisible[val] === false) table?.hideColumn?.(val);
            else table?.showColumn?.(val);
        }
        setColumnsVisible(columnVisible);
    }

      const resetMask = () => resetTabulatorMask({
        page: 'GaugeCalibrationAdd',
        defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_GAUGE_CALIBRATION_ADD,
        ref,
        columns,
        setColumnsVisible,
      });

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { setUserMaskFilter("GaugeCalibrationAdd","set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => { setUserMaskFilter("GaugeCalibrationAdd","set_filters",null,[],null); getTable()?.clearHeaderFilter?.(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
             {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { setUserMaskFilter("GaugeCalibrationAdd","set_sorters",null,null,null,cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => { setUserMaskFilter("GaugeCalibrationAdd","set_sorters",null,null,null,[]); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('GaugeCalibrationAdd');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value) {
        const table = getTable();
        const columnVisible = { ...columnsVisible };
        for (const val in columnVisible) {
            if (val !== 'specific_id' && val !== 'editor' && val !== 'end_of_validity') {
                columnVisible[val] = !!value;
                if (value) table?.showColumn?.(val);
                else table?.hideColumn?.(val);
            }
        }
        setColumnsVisible(columnVisible);
      }


    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewCalibration()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyGaugeCalibration()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewGaugeCalibration()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst(getTable())} disabled={scrollIcons || !gauge?.id} title={t('Common.FirstRecord')}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp(getTable())} disabled={scrollIcons || !gauge?.id} title={t('Common.Previous')}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown(getTable())} disabled={scrollIcons || !gauge?.id} title={t('Common.Next')}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast(getTable())} disabled={scrollIcons || !gauge?.id} title={t('Common.LastRecord')}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('Calibration.EditGaugeCalibration'),"GaugeCalibrationAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button onClick={() => setFastView("GaugeCalibrationAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={75}>
        <form onSubmit={formik.handleSubmit} className='w-full'>
        <div className="relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-3 gap-1 mb-2'>
            {/* 1. stĺpec – ako v Karte meradla: názov, inventárne č., štatút, max interval, výrobné č., dátum nákupu */}
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.EVIDENCNA_KARTA_MERADIEL')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {gauge?.specific_id}</label>}
                <div>
                    <label htmlFor="gauge_name" className="block text-md font-semibold text-gray-800">{t('Ui.R67.NAZOV_MERADLA')}</label>
                    <input name='gauge_name' type="text" readOnly value={formGaugeCalibration?.gauge_name} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                </div>
                <div>
                    <label htmlFor="inventory_number" className="block text-md font-semibold text-gray-800">{t('Ui.R67.INVENTARNE_CISLO')}</label>
                    <input name='inventory_number' type="text" readOnly value={formGaugeCalibration?.inventory_number} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                </div>
                <div>
                    <label htmlFor="gauge_status" className="block text-md font-semibold text-gray-800">{t('Ui.R67.STATUT_MERADLA')}</label>
                    <select name='gauge_status' disabled value={formGaugeCalibration?.gauge_status} className='block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="Kalibrované">{t('Ui.R67.Pracovne_kalibrovane_meradlo')}</option>
                        <option value="Informatívne">{t('Ui.R67.Informativne_meradlo')}</option>
                        <option value="Vyradené">{t('Ui.R67.Vyradene_meradlo')}</option>
                    </select>
                    {((formGaugeCalibration?.state ?? gauge?.state ?? '').toString().trim().toLowerCase() === 'vyradené') && (
                        <p className="mt-1 text-sm font-medium text-gray-700">Expirácia: <span className="font-semibold">DEA</span></p>
                    )}
                </div>
                <div>
                    <label htmlFor="max_calibration_interval" className="block text-md font-semibold text-gray-800 mt-2">{t('Calibration.Column.MaxCalibrationInterval')}</label>
                    <select name='max_calibration_interval' disabled value={formGaugeCalibration?.max_calibration_interval} className='block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="0">0</option>
                        <option value="3">3 mesiace</option>
                        <option value="6">6 mesiacov</option>
                        <option value="12">12 mesiacov</option>
                        <option value="24">24 mesiacov</option>
                        <option value="48">48 mesiacov</option>
                        <option value="60">60 mesiacov</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="serial_number" className="block text-md font-semibold text-gray-800">{t('MachineAdd.Label.SerialNumber')}</label>
                    <input name='serial_number' type="text" readOnly value={formGaugeCalibration?.serial_number} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                </div>
            </div>
            {/* 2. stĺpec – dátum nákupu navrch, potom lokalita, výrobca, typ, kategória, kal. firma */}
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div>
                    <label htmlFor="purchase_date" className="block text-md font-semibold text-gray-800">{t('Ui.R67.DATUM_NAKUPU')}</label>
                    <input name='purchase_date' type="text" readOnly value={formGaugeCalibration?.purchase_date} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                </div>
                <div>
                    <label htmlFor="state" className="block text-md font-semibold text-gray-800">{t('Calibration.Column.Location')}</label>
                    <select name='state' disabled value={formGaugeCalibration?.state} className='block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="Na pracovisku">Na pracovisku</option>
                        <option value="Na kalibrácií">{t('Calibration.OnCalibration')}</option>
                        <option value="Na oprave">Na oprave</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="manufacturer" className="block text-md font-semibold text-gray-800">{t('Ui.R67.VYROBCA_MERADLA')}</label>
                    <input name='manufacturer' type="text" readOnly value={formGaugeCalibration?.manufacturer} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                </div>
                <div>
                    <label htmlFor="gauge_type" className="block text-md font-semibold text-gray-800">{t('Calibration.Column.GaugeType')}</label>
                    <select name='gauge_type' disabled value={formGaugeCalibration?.gauge_type} className='block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="Digitálne">{t('Calibration.Digital')}</option>
                        <option value="Analógové">{t('Calibration.Analog')}</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="gauge_category" className="block text-md font-semibold text-gray-800">{t('Ui.R67.KATEGORIA_MERADLA')}</label>
                    <select name='gauge_category' disabled value={formGaugeCalibration?.gauge_category} className='block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="PMU-Pracovné meradlo">{t('Calibration.Type.PMU')}</option>
                        <option value="SM-Skúšovné meradlo">{t('Calibration.Type.SM')}</option>
                        <option value="ZM-Zálohové meradlo">{t('Calibration.Type.ZM')}</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="calibration_company_id" className="block text-md font-semibold text-gray-800">{t('Ui.R67.KALIBRACNA_FIRMA')}</label>
                    <select name="calibration_company_id" value={formGaugeCalibration?.calibration_company_id} disabled className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                        <option value="">{t('Ui.R67.Vyber_kal_firmu')}</option>
                        {(state.calibration_companies || []).map((calibration_company) => (
                            <option key={calibration_company.id} value={calibration_company.id}>{calibration_company.name}</option>
                        ))}
                    </select>
                </div>
            </div>
            {/* 3. stĺpec – popis meradla navrch, potom správca, používateľ, predloha, protokoly */}
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div>
                    <label htmlFor="gauge_description" className="block text-md font-semibold text-gray-800">{t('Ui.R67.POPIS_MERADLA')}</label>
                    <textarea name='gauge_description' readOnly value={formGaugeCalibration?.gauge_description} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                </div>
                <div>
                    <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.ODDELENIE_SPRAVCU')}</label>
                    <input type="text" readOnly value={formGaugeCalibration?.trustee?.department?.name ?? ''} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md" />
                </div>
                <div>
                    <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.MENO_SPRAVCU')}</label>
                    <input type="text" readOnly value={formGaugeCalibration?.trustee?.name ?? ''} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md" />
                </div>
                <div>
                    <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.ODDELENIE_POUZIVATELA')}</label>
                    <input type="text" readOnly value={formGaugeCalibration?.user?.department?.name ?? ''} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md" />
                </div>
                <div>
                    <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.MENO_POUZIVATELA')}</label>
                    <input type="text" readOnly value={formGaugeCalibration?.user?.name ?? ''} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md" />
                </div>
                <div>
                    <label className="block text-md font-semibold text-gray-800">POVINNÁ PRÍLOHA</label>
                    <input type="text" readOnly value={formGaugeCalibration?.required_attachment ? t('Common.Yes') : t('Common.No')} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md" />
                </div>
                <div>
                    <label className="block text-md font-semibold text-gray-800">PREDLOHA</label>
                    {Array.isArray(templates) && templates.length > 0 && templates.map((img) => (
                        <table key={img.id} className='w-full border border-separate border-gray-400 rounded-md bg-gray-100 mb-4'>
                            <tbody>
                            <tr>
                                <td className='text-black h-10'><div className='flex flex-row p-2'>
                                    <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                        {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                            <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                                        ) : (
                                            <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                        )}
                                    </div>
                                    <div className='flex flex-col ml-4'>
                                        <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                    </div>
                                </div></td>
                            </tr>
                            </tbody>
                        </table>
                    ))}
                </div>
                {selectedCalibration?.id && (
                <div className="mt-4">
                    {Array.isArray(images) && images.length > 0 ? images.map((img) => (
                        <table key={img.id} className='w-full border border-separate border-gray-400 rounded-md bg-gray-100 mb-4'>
                            <tbody>
                            <tr>
                                <td className='text-black h-10'><div className='flex flex-row p-2'>
                                    <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                        {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                            <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                                        ) : (
                                            <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                        )}
                                    </div>
                                    <div className='flex flex-col ml-4'>
                                        <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                    </div>
                                </div></td>
                            </tr>
                            </tbody>
                        </table>
                    )) : null}
                </div>
                )}
            </div>
            </div> 
            </div>
             </form>
             </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    {effectiveGaugeId ? (
    <ReactTabulator
      key={`gauge-calibration-add-${effectiveGaugeId}`}
      onRef={(r) => (ref.current = r?.current)}
      className='h-full w-full'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            tableBuiltRef.current = true;
            const table = getTable();
            if (!table) return;
            const mask = state.user_mask_filters?.filter(m => m.page === 'GaugeCalibrationAdd') ?? [];
            if (mask.length > 0) {
                const attributes = safeParse(mask[0].attributes, []);
                const filters = safeParse(mask[0].filters, []);
                const sorters = parseSorters(mask[0].sorters);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) table.setColumnLayout?.(attributes);
                if (json_columns && typeof json_columns === 'object') {
                    setColumnsVisible(json_columns);
                    for (const column in json_columns) {
                        if (json_columns[column] === false) table.hideColumn?.(column);
                        else table.showColumn?.(column);
                    }
                }
                if (Array.isArray(sorters) && sorters.length > 0) table.setSort?.(sorters.map(s => ({ column: s.column ?? s.field, dir: s.dir })));
                if (Array.isArray(filters) && filters.length > 0) {
                    filters.forEach(f => table.setHeaderFilterValue?.(f.field, f.value ?? '', true));
                } else {
                    table.clearHeaderFilter?.();
                }
                refreshFromStart();
            }
        },
        renderComplete: () => restoreHScroll(),
        ...getTabulatorPersistLayoutEvents('GaugeCalibrationAdd', ref, setUserMaskFilter),
      }}
      options={{
        layout: 'fitColumns',
        renderHorizontal: 'virtual',
        movableColumns: true,
        rowHeight: 30,
        headerSortTristate: true,
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.GaugeCalibrationAdd'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: 'active',
        autoResize: false,
        ajaxURL: '/api/gauge_calibrations/paged',
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: PAGE_SIZE,
        filterMode: 'remote',
        sortMode: 'remote',
        pagination: false,
        ajaxRequesting: () => {
            captureHScroll();
            const table = getTable();
            if (table?.initialized) table.alert?.(t('Common.LoadingData'));
            return true;
        },
        ajaxResponse: (url, params, response) => {
            getTable()?.clearAlert?.();
            return response;
        },
        ajaxError: () => {
            getTable()?.clearAlert?.();
        },
        initialSort: [{ column: 'calibration_date', dir: 'desc' }],
      }}/>
    ) : (
      <div className="flex flex-col items-center justify-center p-4 text-zinc-500 text-sm">
        Vyberte meradlo alebo otvorte kalibráciu pre konkrétne meradlo – tabuľka kalibrácií sa načíta.
      </div>
    )}
    </SplitterPanel>
</Splitter> 
    <Dialog header={t('Calibration.EditCalibration')} visible={visibleCalibration} style={{ width: '40vw' }} onHide={() => hideEditCalibration()}>
    <form onSubmit={formikUpdate.handleSubmit}>
            <div>   
                <h3 className="text-xl font-semibold text-left text-zinc-900 mb-2">{t('Ui.R67.ZAZNAM_KALIBRACIE_MERADLA')}</h3>
                {(gauge?.gauge_status === 'Vyradené' || formGaugeCalibration?.gauge_status === 'Vyradené') && (
                  <p className="mb-3 px-3 py-2 rounded bg-orange-100 text-orange-900 text-sm font-medium border border-orange-300">{t('Ui.R67.Toto_meradlo_je_vyradene_deaktivovane_Upravy_kalibracie_su_p')}</p>
                )}
                {gauge?.required_attachment && (
                  <p className="mb-3 px-3 py-2 rounded bg-amber-100 text-amber-900 text-sm font-medium">{t('Calibration.GaugeAttachmentRequired')}</p>
                )}
                        <label
                            htmlFor="validator_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            KALIBROVAL
                        </label>
                        <select
                        name="validator_id" onChange={formikUpdate.handleChange} value={formikUpdate.values.validator_id}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value=''>{t('Common.InternalEmployee')}</option>
                          {(state.calibration_companies || []).map((calibration_company) => (
                            <option key={calibration_company.id} value={calibration_company.id}>{calibration_company.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="calibration_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.DATUM')}</label>
                        <input required
                            name='calibration_date'
                            type="date"
                            onChange={formikUpdate.handleChange} value={formikUpdate.values.calibration_date}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="calibration_number_protocol"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.CISLO_KAL_PROTOKOLU')}</label>
                        <input
                            name='calibration_number_protocol'
                            type="text"
                            onChange={formikUpdate.handleChange} value={formikUpdate.values.calibration_number_protocol}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="verification_result"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.VYSLEDOK_OVERENIA')}</label>
                        <select required
                        name='verification_result'
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.verification_result}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="OK">OK</option>
                          <option value="NOK">NOK</option>
                        </select>
                        </div> 
                        <div>
                        <label
                            htmlFor="contractor_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.ZAZNAM_VYKONAL')}</label>
                        <select required
                        name="contractor_id" onChange={formikUpdate.handleChange} value={formikUpdate.values.contractor_id}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Common.SelectEmployee')}</option>
                          {(state.employees || []).map((employee) => (
                            <option key={employee.id} value={employee.id}>{employee.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <input
                            name='description'
                            type="text"
                            onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="gauge_category"
                            className="block text-md font-semibold text-gray-800"
                        >
                            PROTOKOL
                        </label>
                        <input
                            name='files' 
                            ref={updateFileListRef}
                            onChange={handleUpdateFileChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='file'/>
                        </div> 
                        {Array.isArray(images) && images.length > 0 && images.map((img) => ( <div key={img.id} className='flex flex-row p-2'>
                            <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                    <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                                ) : (
                                    <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                )}
                            </div>
                                <div className='flex flex-col ml-4'>
                                <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                                </div>
                            </div>))}
                            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
            </form>
      </Dialog>
        <Dialog header={t('Calibration.NewCalibration')} visible={showGaugeCalibrationAdd} style={{ width: '40vw' }} onHide={() => setShowGaugeCalibrationAdd(false)}>
        <form onSubmit={formik.handleSubmit}>
            <div>   
                {(gauge?.state === 'Vyradené' || formGaugeCalibration?.state === 'Vyradené') && (
                  <p className="mb-3 px-3 py-2 rounded bg-orange-100 text-orange-900 text-sm font-medium border border-orange-300">{t('Ui.R67.Upozornenie_Pridavate_zaznam_kalibracie_k_vyradenemu_deaktiv')}</p>
                )}
                {gauge?.required_attachment && (
                  <p className="mb-3 px-3 py-2 rounded bg-amber-100 text-amber-900 text-sm font-medium">{t('Calibration.GaugeAttachmentRequired')}</p>
                )}
                        <label
                            htmlFor="validator_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            KALIBROVAL
                        </label>
                        <select
                        name="validator_id" onChange={formik.handleChange} value={formik.values.validator_id}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value=''>{t('Common.InternalEmployee')}</option>
                          {(state.calibration_companies || []).map((calibration_company) => (
                            <option key={calibration_company.id} value={calibration_company.id}>{calibration_company.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="calibration_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.DATUM')}</label>
                        <input required
                            name='calibration_date'
                            type="date"
                            onChange={formik.handleChange} value={formik.values.calibration_date}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="calibration_number_protocol"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.CISLO_KAL_PROTOKOLU')}</label>
                        <input
                            required
                            name='calibration_number_protocol'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.calibration_number_protocol}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="verification_result"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.VYSLEDOK_OVERENIA')}</label>
                        <select required
                        name='verification_result'
                        onChange={formik.handleChange} value={formik.values.verification_result}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="OK">OK</option>
                          <option value="NOK">NOK</option>
                        </select>
                        </div> 
                        <div>
                        <label
                            htmlFor="contractor_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.ZAZNAM_VYKONAL')}</label>
                        <select required
                        name="contractor_id" onChange={formik.handleChange} value={formik.values.contractor_id}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Common.SelectEmployee')}</option>
                          {(state.employees || []).map((employee) => (
                            <option key={employee.id} value={employee.id}>{employee.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <input
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="gauge_category"
                            className="block text-md font-semibold text-gray-800"
                        >
                            PROTOKOL
                        </label>
                        <input
                            required={formGaugeCalibration?.gauge_status == 'Kalibrované' ? true : false}
                            name='files' 
                            ref={fileListRef}
                            onChange={handleFileChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='file'/>
                        </div> 
                        {Array.isArray(images) && images.length > 0 && images.map((img) => ( <div key={img.id} className='flex flex-row p-2'>
                            <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                    <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                                ) : (
                                    <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                )}
                            </div>
                                <div className='flex flex-col ml-4'>
                                <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                                </div>
                            </div>))}
                            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
            </form>
            </Dialog>
            <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2 || index==9) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("GaugeCalibrationAdd","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
            </div>
            </> 
            );
} 
